module.exports = __webpack_public_path__ + "img/rocket-blue.10bc13fc.gif";